import { Navigate } from 'react-router'

import { AWXConnectedAccountStatus } from '@ankor-io/common/types/awx'

import { useConnectedAccount } from '@/providers/connectedAccount'
import { useUserContext } from '@/providers/user/useUserContext'
import Loading from '@/ui-components/Loading'
import { KYCRFIComponent } from '@/views/components/KYC/KYCRFIComponent'
import { KYCType } from '@/views/components/KYC/types'

const KYCRFIPage: React.FC = () => {
  const { isLoading, connectedAccounts } = useConnectedAccount()
  const { activeConnectedAccountId } = useUserContext()
  const activeConnectedAccount = connectedAccounts.find((c) => c.id === activeConnectedAccountId)

  if (isLoading) {
    return <Loading />
  }

  if (!activeConnectedAccount) {
    return (
      <Navigate
        to="/"
        replace
      />
    )
  }

  if (activeConnectedAccount.status === AWXConnectedAccountStatus.CREATED) {
    return (
      <KYCRFIComponent
        connectedAccount={activeConnectedAccount}
        type={KYCType.KYC}
      />
    )
  }

  if (activeConnectedAccount.status === AWXConnectedAccountStatus.ACTION_REQUIRED) {
    return (
      <KYCRFIComponent
        connectedAccount={activeConnectedAccount}
        type={KYCType.KYCRFI}
      />
    )
  }

  return (
    <Navigate
      to="/"
      replace
    />
  )
}

export default KYCRFIPage
